export const getClient = /* GraphQL */ `
  query GetClient($id: ID!) {
    getClient(id: $id) {
      facilitySettings {
        groupPurchaseHomeImageS3Keys
        facilityAvatarS3Keys
        clientGroupPurchaseRule
        }
    }
  }
`;
